import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import {
    ProductNavBar,
    ProductNavLink
} from "@/components/wpl/product-navbar/src";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const ConfluenceSoftwareNav = () => {
    const intl = useIntl();

    const dataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-event": "clicked"
    };

    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software/confluence")}
            productName="confluence"
            freeHref={useLocalizedHref("/software/confluence/free")}
            ariaLabel={intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.logo-label",
                defaultMessage: "Confluence logo"
            })}
            dataProductKey="confluence"
            logoLinkWrapperWidth="189px"
        >
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.features",
                    defaultMessage: "Features"
                })}
                href={useLocalizedHref("/software/confluence/features")}
                dataEventProps={dataEventProps}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                    defaultMessage: "Resources"
                })}
                href={useLocalizedHref("/software/confluence/resources")}
                dataEventProps={dataEventProps}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.templates",
                    defaultMessage: "Templates"
                })}
                href={useLocalizedHref("/software/confluence/templates")}
                dataEventProps={dataEventProps}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                    defaultMessage: "Pricing"
                })}
                href={useLocalizedHref("/software/confluence/pricing")}
                dataEventProps={dataEventProps}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                    defaultMessage: "Enterprise"
                })}
                href={useLocalizedHref("/software/confluence/enterprise")}
                dataEventProps={dataEventProps}
            />
        </ProductNavBar>
    );
};

ConfluenceSoftwareNav.displayName = "ConfluenceSoftwareNav";

export default ConfluenceSoftwareNav;
